export default {
  /** 查询登录注册推广图*/
  getPromoteInfo: '/api/spread-picture/get-by-country-code',
}
